<wms-dialog id="pushChangesModal" customClasses="push-vcs-project-dialog">
    <wms-dialog-header (onClose)="closeDialog()"
        title="{{locale['LABEL_VCS_MENU_PUSH_PROJECT']}}" helpTitle="{{locale['LABEL_VCS_MENU_PUSH_PROJECT']}}"
        helpLink="https://docs.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#push-changes"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
      <div class="app-dialog-body modal-body vcsPushDialogue" name="vcsPushDialogue">
        <form enctype="multipart/form-data" class="wm-form">
            <wms-message *ngIf="vcsService.msgData.show" hideclose="true" [scopeDataset]="vcsService.msgData"></wms-message>
            <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-md-4">{{locale['LABEL_PROJECT_NAME']}}:</label>
                <div class="col-md-8">
                    <label class="control-label app-label ">{{projectDetails.displayName}} </label>
                </div>
            </div>
            <div  *ngIf="!isEmpty(vcsService.pushChangesInfo.defaultCommitMsg)" class="form-group app-composite-widget clearfix">
                <label class="control-label app-label required col-md-4">
                    {{locale['LABEL_VCS_COMMIT']}}:
                </label>
                <div class="col-md-8">
                    <textarea placeholder="{{locale['MESSAGE_VCS_COMMIT']}}" [(ngModel)]="vcsService.pushChangesInfo.commitMsg"
                        name="commitMsg" class="form-control app-textarea push-commit-msg"></textarea>
                    <textarea rows="5" [(ngModel)]="vcsService.pushChangesInfo.defaultCommitMsg" name="defaultCommitMsg" readonly
                        class="form-control app-textarea push-commit-msg"></textarea>
                </div>
            </div>
          <div class="form-group app-composite-widget clearfix" *ngIf="this.projectService.teamProjectObject.vcsAccountDTO && this.projectService.teamProjectObject.vcsAccountDTO.migrationCommitEnabled && !isEmpty(vcsService.pushChangesInfo.migrationCommitDis)">
            <label class="control-label app-label required col-md-4">
              {{locale['LABEL_VCS_MIGRATION_COMMIT']}}:
            </label>
            <div class="col-md-8">
                    <textarea placeholder="{{locale['MESSAGE_VCS_COMMIT']}}" [disabled]="!projectService.teamProjectObject.vcsAccountDTO.promptToEditMigrationMessage" [(ngModel)]="vcsService.pushChangesInfo.migrationCommitMsg"
                              name="migrationCommitMsg" class="form-control app-textarea push-commit-msg"></textarea>
                    <textarea rows="5" [(ngModel)]="vcsService.pushChangesInfo.migrationCommitDis" name="migrationCommitDis" readonly
                              class="form-control app-textarea push-commit-msg"></textarea>
            </div>
          </div>
        </form>
      </div>
    </wms-dialog-body>
    <wms-dialog-footer>
        <button class="btn button-secondary app-button"
            (click)="closeDialog()" [disabled]="vcsService.isActionDisabled">{{locale['LABEL_CANCEL']}}</button>
        <button class="btn btn-primary" (click)="pushProjectChanges()" [disabled]="vcsService.isDisablePushBtn || vcsService.isActionDisabled">{{locale['LABEL_OK']}}</button>
    </wms-dialog-footer>
</wms-dialog>
